module.exports = __webpack_public_path__ + "assets/aws_authenticated_icon.a77e3be7.svg";